import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
export var SideBarKey = 'side-bar';
var isElementScrolledToBottom = function (element) {
    return element.scrollHeight - element.scrollTop === element.offsetHeight;
};
var SideBar = /** @class */ (function (_super) {
    __extends(SideBar, _super);
    function SideBar(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function () {
            var sideBarBodyElement = _this.sideBarBodyRef.current;
            if (sideBarBodyElement) {
                if (!_this.state.isScrolledToBottom && isElementScrolledToBottom(sideBarBodyElement)) {
                    _this.setState({ isScrolledToBottom: true });
                }
                else if (_this.state.isScrolledToBottom && !isElementScrolledToBottom(sideBarBodyElement)) {
                    _this.setState({ isScrolledToBottom: false });
                }
            }
        };
        _this.handleScroll = function (e) {
            var state = _this.state;
            var element = e.currentTarget;
            if (element.scrollTop > 0 && !state.isScrolled) {
                _this.setState({ isScrolled: true });
            }
            else if (element.scrollTop === 0 && state.isScrolled) {
                _this.setState({ isScrolled: false });
            }
            if (!state.isScrolledToBottom && isElementScrolledToBottom(element)) {
                _this.setState({ isScrolledToBottom: true });
            }
            else if (state.isScrolledToBottom && !isElementScrolledToBottom(element)) {
                _this.setState({ isScrolledToBottom: false });
            }
        };
        _this.state = {
            isScrolled: false,
            isScrolledToBottom: true,
        };
        _this.sideBarBodyRef = React.createRef();
        return _this;
    }
    SideBar.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var classNames = namespacedClassnames(SideBarKey, props.className, { scrolled: state.isScrolled, 'scrolled-to-bottom': state.isScrolledToBottom });
        var maybeHeader = props.headerRenderer ? (React.createElement("div", { className: 'side-bar-header' }, props.headerRenderer())) : null;
        return (React.createElement("div", { className: classNames },
            maybeHeader,
            React.createElement("div", { className: 'side-bar-body', onScroll: this.handleScroll, ref: this.sideBarBodyRef }, props.children)));
    };
    return SideBar;
}(React.PureComponent));
export { SideBar };
//# sourceMappingURL=index.js.map